import React from 'react';
import UserProfileImage, { getInitials } from '../components/userProfileImage';
import { Spinner } from 'reactstrap';

const Loading = () => <Spinner
    as="span"
    animation="grow"
    size="sm"
    role="status"
    aria-hidden="true"
/>;

export default function PendingComment({ comment, myProfile }) {
    return (
        <div key={comment.Id} className="activity_comment" style={{fontStyle: 'italic', backgroundColor: '#eee'}}>
            <UserProfileImage
                id={myProfile?.Id}
                initials={getInitials(myProfile)}
                photo={null} />
            <div className="comment_container">
                <div className="comment_header">
                    <span className="comment_actionby">You</span>
                    <span className="comment_separator">&middot;</span>
                    <span className="comment_date">
                        Sending... <Loading />
                    </span>
                </div>
                <div className="comment_content">
                    <span>{comment}</span>
                </div>
            </div>
        </div>
    );
}